import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type THIS_API = ApiDefinition['/e-signature-requests/{eSignatureRequestId}/void']['PUT'];
type Input = THIS_API['params'];
type Output = THIS_API['response'];

const voidESignatureRequest = async ({ eSignatureRequestId }: Input): Promise<Output> => {
  const response = await noodleApiClient.put(`/e-signature-requests/${eSignatureRequestId}/void`);
  return response.data;
};

export default voidESignatureRequest;
